import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import Footer from "./Footer";

const courseData = {
  AutoCAD: {
    title: "AutoCAD Course",
    description:
      "Comprehensive AutoCAD training covering 2D drafting and design.",
    keywords: [
      "2D drafting",
      "Design fundamentals",
      "AutoCAD tools",
      "Technical drawing",
    ],
    image: "/t&d/autocad.png",
    videoUrl: "https://www.youtube.com/embed/1Z2d6k6v7xA", // Example YouTube video URL
  },
  "2D Drafting": {
    title: "2D Drafting Course",
    description:
      "Learn precise 2D drafting techniques for engineering projects.",
    keywords: [
      "Engineering drafting",
      "Precision drawing",
      "Blueprint reading",
      "CAD software",
    ],
    image: "/t&d/2D drafting.png",
    videoUrl: "https://www.youtube.com/embed/2d-drafting-video", // Replace with actual video URL
  },
  "3D Modeling": {
    title: "3D Modeling Course",
    description: "Master 3D modeling skills using industry-standard software.",
    keywords: [
      "3D design",
      "Modeling software",
      "Rendering",
      "Animation basics",
    ],
    image: "/t&d/3D modeling.png",
    videoUrl: "https://www.youtube.com/embed/3d-modeling-video", // Replace with actual video URL
  },
  Revit: {
    title: "Revit Course",
    description:
      "In-depth Revit training for building information modeling (BIM).",
    keywords: [
      "BIM",
      "Building design",
      "Revit tools",
      "Project collaboration",
    ],
    image: "/t&d/revit.png",
    videoUrl: "https://www.youtube.com/embed/revit-video", // Replace with actual video URL
  },
  Inventor: {
    title: "Inventor Course",
    description:
      "Professional training in Autodesk Inventor for 3D mechanical design.",
    keywords: [
      "Mechanical design",
      "3D modeling",
      "Autodesk Inventor",
      "Product development",
    ],
    image: "/t&d/inventor.png",
    videoUrl: "https://www.youtube.com/embed/inventor-video", // Replace with actual video URL
  },
};

const CourseDetail = () => {
  const { courseName } = useParams();
  const navigate = useNavigate();
  const course = courseData[courseName];

  if (!course) {
    return (
      <Container className="py-5 text-center">
        <h2>Course not found</h2>
        <Button variant="primary" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Container>
    );
  }

  return (
    <div>
      {/* Hero Section */}
      <div
        style={{
      // backgroundImage: `url(${course.image})`,
      background: "linear-gradient(135deg,rgb(25, 79, 123) 0%, #764ba2 100%)",
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight: "450px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
      fontWeight: "700",
      fontSize: "3rem",
    }}
  >
    <h1>{course.title}</h1>
  </div>

      {/* About Section */}
      <Container className="py-5">
        <Row className="align-items-center gy-4">
          <Col md={6} className="mb-4 mb-md-0">
            <h2 className="mb-3">{course.title} Overview</h2>
            <p className="lead">{course.description}</p>
            <h5>Keywords:</h5>
            <ul>
              {course.keywords.map((keyword, index) => (
                <li key={index}>{keyword}</li>
              ))}
            </ul>
          </Col>
          <Col md={6}>
            <img
              src={course.image}
              alt={course.title}
              className="img-fluid rounded shadow-sm"
              style={{ borderRadius: "12px" }}
            />
          </Col>
        </Row>
      </Container>

      {/* Video Section */}
      <Container className="py-5">
        <h2 className="mb-4">{course.title} Video</h2>
        <div className="ratio ratio-16x9 shadow rounded">
          <iframe
            src={course.videoUrl}
            title={course.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: "12px" }}
          ></iframe>
        </div>
      </Container>

      <Footer />
    </div>
  );
};

export default CourseDetail;
